import { RestaurantMenuLinkPlateItemWithAppearance } from "shared-ui/RestaurantMenuLinkPlate/utils";
import { useState } from "react";
import { MenuItemAppearancePreviewFragment } from "../../../../../types";

type RestaurantMenuLinkPlateDialogState =
  | {
      type: "newMenuItem";
      menuItemAppearance: MenuItemAppearancePreviewFragment;
      newPlateItem: RestaurantMenuLinkPlateItemWithAppearance | null;
    }
  | {
      type: "editMenuItem";
      plateItem: RestaurantMenuLinkPlateItemWithAppearance;
    }
  | {
      type: "menuSections";
    };

export const usePlateDialogState = () => {
  return useState<RestaurantMenuLinkPlateDialogState>({
    type: "menuSections",
  });
};
